export default {
   init() {
      const container = document.querySelector('.wp-block-flip-blocks-filter-apartments');
      if (!container) return;

      const elemFields = container.querySelectorAll('.filter-apartments-block__field');
      const elemBody = container.querySelector('.filter-apartments-block__body');
      const elemInner = container.querySelector('.filter-apartments-block__inner');
      const showMoreBtn = container.querySelector('.show-more-filters');

      // Get query original from data-query
      let currentQuery = JSON.parse(elemInner?.dataset.query || '{}');
      const perPage = parseInt(elemInner?.dataset.perPage) || 12;
      let isLoading = false;

      // ─── Filter dropdown ───────────────────────────────────────────

      elemFields.forEach((field) => {
         const elemLabel = field.querySelector('.filter-apartments-block__field--label');
         const elemDropdown = field.querySelector('.filter-apartments-block__field--dropdown');
         if (!elemLabel || !elemDropdown) return;

         elemLabel.addEventListener('click', () => {
            const isActive = field.classList.contains('active');
            elemFields.forEach((f) => f.classList.remove('active'));
            if (!isActive) field.classList.add('active');
         });

         elemDropdown.querySelectorAll('li').forEach((li) => {
            li.addEventListener('click', () => {
               const val = li.dataset.val;
               const text = li.textContent.trim();

               const dataKey = Object.keys(elemLabel.dataset)[0];
               if (dataKey !== undefined) {
                  elemLabel.dataset[dataKey] = val;
               }
               const icon = elemLabel.querySelector('.filter-apartments-block__field--icon');
               elemLabel.textContent = text;
               if (icon) elemLabel.appendChild(icon);

               elemDropdown.querySelectorAll('li').forEach((l) => l.classList.remove('selected'));
               li.classList.add('selected');
               field.classList.remove('active');

               // Reset to page 1 when filter changed
               fetchApartments({ paged: 1, isLoadMore: false });
            });
         });
      });

      // ─── Click outside close dropdown ─────────────────────────────────

      document.addEventListener('click', (e) => {
         if (!e.target.closest('.filter-apartments-block__field')) {
            elemFields.forEach((f) => f.classList.remove('active'));
         }
      });

      // ─── Load more ─────────────────────────────────────────────────

      container.addEventListener('click', (e) => {
         const btn = e.target.closest('.filter-apartments-block__loadmore-btn');
         if (!btn) return;

         const currentPage = parseInt(btn.dataset.currentPage) || 1;
         const maxPages = parseInt(btn.dataset.maxPages) || 1;

         if (currentPage >= maxPages || isLoading) return;

         fetchApartments({ paged: currentPage + 1, isLoadMore: true });
      });

      // ─── Show more filters (mobile) ────────────────────────────────

      if (showMoreBtn) {
         const hiddenFields = container.querySelectorAll('.filter-apartments-block__field.hide-mb');

         showMoreBtn.addEventListener('click', () => {
            const isExpanded = showMoreBtn.classList.contains('is-expanded');

            hiddenFields.forEach((field) => {
               field.classList.toggle('hide-mb', isExpanded);
            });

            showMoreBtn.textContent = isExpanded ? 'Show more filters' : 'Show less filters';
            showMoreBtn.classList.toggle('is-expanded', !isExpanded);
         });
      }

      function updateResultsCount(found_posts) {
         const resultsWrap = container.querySelector('.filter-apartments-block__results');
         if (!resultsWrap) return;

         if (found_posts === 0) {
            resultsWrap.innerHTML = 'No apartments found';
            return;
         }

         const currentCount = elemBody.querySelectorAll('.apartment-card').length;

         if (currentCount >= found_posts) {
            resultsWrap.innerHTML = `Showing <span class="filter-apartments-block__results-showing">${found_posts}</span> results`;
         } else {
            resultsWrap.innerHTML = `Showing <span class="filter-apartments-block__results-showing">${currentCount}</span> of <span class="filter-apartments-block__results-total">${found_posts}</span> results`;
         }
      }

      // ─── Fetch ─────────────────────────────────────────────────────

      function buildParams() {
         const params = { ...currentQuery };
         params.posts_per_page = perPage;

         elemFields.forEach((field) => {
            const label = field.querySelector('.filter-apartments-block__field--label');
            if (!label) return;

            const dataKey = Object.keys(label.dataset)[0];
            const val = label.dataset[dataKey];
            if (!val) return;

            const keyMap = {
               village: 'village',
               location: 'location',
               bedroom: 'bedrooms',
               bathroom: 'bathrooms',
               carpark: 'carports',
               price: 'price',
               sort: 'orderBy',
            };

            const paramKey = keyMap[dataKey];
            if (paramKey) params[paramKey] = val;
         });

         return params;
      }

      function fetchApartments({ paged = 1, isLoadMore = false }) {
         if (isLoading) return;
         isLoading = true;

         const params = buildParams();

         params.paged = paged;

         container.classList.add('is-loading');

         const formData = new FormData();
         formData.append('action', 'ajax_filter_apartments');
         formData.append('nonce', block_script.nonce);
         Object.entries(params).forEach(([key, val]) => {
            formData.append(key, val);
         });

         fetch(block_script.ajax_url, {
            method: 'POST',
            body: formData,
         })
            .then((res) => {
               console.log('Response status:', res.status);
               return res.json();
            })
            .then((data) => {
               if (!data.success) return;

               const { html, found_posts, max_num_pages } = data.data;

               if (isLoadMore) {
                  elemBody.insertAdjacentHTML('beforeend', html);
               } else {
                  elemBody.innerHTML = html;
               }

               const resultsEl = container.querySelector('#data-results');
               if (resultsEl) resultsEl.textContent = found_posts;

               updateResultsCount(found_posts);
               updateLoadMore(paged, max_num_pages);
            })
            .catch((err) => console.error('AJAX error:', err))
            .finally(() => {
               isLoading = false;
               container.classList.remove('is-loading');
            });
      }

      function updateLoadMore(currentPage, maxPages) {
         const loadMoreWrap = container.querySelector('.filter-apartments-block__loadmore');
         const btn = container.querySelector('.filter-apartments-block__loadmore-btn');

         if (currentPage >= maxPages) {
            if (loadMoreWrap) loadMoreWrap.style.display = 'none';
         } else {
            if (loadMoreWrap) loadMoreWrap.style.display = '';
            if (btn) {
               btn.dataset.currentPage = currentPage;
               btn.dataset.maxPages = maxPages;
            }
         }
      }
   },
};